<template>
    <div class="wt-container">
        <p class="introduction-text">
            This table shows all sectors and crops in {{assessment.getCountryOrBasinName()}}, and their annual green, blue and grey water footprints. 
        </p>
        <CountryOrBasinSelector/>
        <Table :columns="columns" :rows="rows"></Table>
    </div>
</template>

<script>
import Table from "@/components/shared/Table.vue";
import CountryOrBasinSelector from "@/components/shared/CountryOrBasinSelector.vue"
import { assessment } from "@/services/assessment-model.js";
import { basinCropsByBasin, countryCropsByCountry, getCrop, worldCrops } from "@/services/entity-model.js";
import { getFunctionGetPercentageString, getFunctionGetWFString } from "@/services/data-tools.js";

export default {
    name: "TableCt",
    components: {
        CountryOrBasinSelector,
        Table
    },
    data() {
        return {
            countryCropsByCountry: countryCropsByCountry,
            basinCropsByBasin: basinCropsByBasin,
            assessment: assessment,
            columns: [
                { key: "cropID", label: "Crop or Sector", dataFunction: function(val) { return getCrop(val).name; }},
                { key: "greenWF", label: "Green WF (m3/yr)", dataFunction: getFunctionGetWFString("yr") },
                { key: "greenWFFraction", label: "% of Green WF", dataFunction: getFunctionGetPercentageString(1) },
                { key: "blueWF", label: "Blue WF (m3/yr)", dataFunction: getFunctionGetWFString("yr") },
                { key: "blueWFFraction", label: "% of Blue WF", dataFunction: getFunctionGetPercentageString(1) },
                { key: "greyWF", label: "Grey WF (m3/yr)", dataFunction: getFunctionGetWFString("yr") },
                { key: "greyWFFraction", label: "% of Grey WF", dataFunction: getFunctionGetPercentageString(1) },
                { key: "wf", label: "Total WF (m3/yr)", dataFunction: getFunctionGetWFString("yr") },
                { key: "wfFraction", label: "% of Total WF", dataFunction: getFunctionGetPercentageString(1) }
            ]
        };
    },
    computed: {
        rows: function() {
            if (assessment.assessmentType.name == "countries") {
                return countryCropsByCountry;
            } else if (assessment.assessmentType.name == "basins") {
                return basinCropsByBasin;
            }
            return worldCrops;
        }
    }
}
</script>

